<template>
  <BreadcrumbPrimeVue
    ref="root"
    v-bind="$attrs"
    :class="lastItemClickable ? 'last-item-clickable' : ''"
    :pt="{ separator: { 'aria-hidden': true } }"
  >
    <slot />
    <!--https://primevue.org/breadcrumb/#api.breadcrumb.slots-->
    <template #separator>
      <i class="pi-chevron-right" />
    </template>
  </BreadcrumbPrimeVue>
</template>

<script setup>
import BreadcrumbPrimeVue from 'primevue/breadcrumb';
import { onMounted, ref } from 'vue';

const root = ref(null);

defineProps({
  lastItemClickable: Boolean,
});

onMounted(() => {
  const links = root.value.$el.getElementsByClassName('p-menuitem-link');
  const active = links[links.length - 1];
  active?.setAttribute('aria-current', 'location');
});
</script>

<style lang="scss" scoped>
@import "@core/csg/src/scss/typography/base.scss";
@import "@core/csg/src/scss/typography/typography-mixins.scss";

.p-breadcrumb {
  @include link-sm;
  overflow-x: visible;
  :deep(ol li a) {
    white-space: wrap;
    @include link-behavior($link-text-decoration,$link-text-sm-offset, $link-hover-text-decoration-thickness, $link-hover-opacity);
  }
  :deep(.p-breadcrumb-list) {
    flex-wrap: wrap;
  }
  :deep(.p-menuitem-text) {
    line-height: normal;
  }
  :deep(.pi-chevron-right::after) {
    content: "/";
    margin: 0 rem-calc(8);
  }

  :deep(ol li:last-child .p-menuitem-text),
  :deep(ol li:last-child a) {
    color: $gray-1-color;
    pointer-events: none;
    cursor: default;
    text-decoration: none;
  }
  &.last-item-clickable :deep(ol li:last-child .p-menuitem-text),
  &.last-item-clickable :deep(ol li:last-child a) {
    pointer-events: auto;
    cursor: pointer;
    text-decoration: underline;
    color: $black;
  }
}
@include breakpoint(medium down) {
  .p-breadcrumb {
    overflow-x: visible;
    word-break: normal;
    overflow-wrap: anywhere;
    :deep(ol li a) {
      white-space: normal;
    }
    :deep(ol li) {
      display: inline;
    }
  }
}
</style>
